// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-report-form {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 95vh;
  width: 100%;
}

.form-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: #f9f9f9;
}

.form-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.5rem;
}

.form-tabs {
  display: flex;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  overflow-x: auto;
  flex-wrap: wrap;
}

.form-tabs button {
  padding: 12px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  border-bottom: 3px solid transparent;
  transition: all 0.3s;
  white-space: nowrap;
  min-width: max-content;
}

.form-tabs button:hover {
  background: #e8e8e8;
  color: #333;
}

.form-tabs button.active {
  color: var(--secondary-color);
  border-bottom-color: var(--secondary-color);
  background: white;
}

.form-section {
  margin-bottom: 30px;
}

.form-section h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header h3 {
  margin: 0;
  border-bottom: none;
  padding-bottom: 0;
}

.add-btn {
  padding: 8px 16px;
  background: var(--secondary-color);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.3s;
}

.add-btn:hover {
  background: #6a9c7a;
}

.form-subsection {
  background: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.subsection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.subsection-header h4 {
  margin: 0;
  color: #555;
  font-size: 1rem;
}

.remove-btn {
  background: #f44336;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: background 0.3s;
}

.remove-btn:hover {
  background: #d32f2f;
}

.empty-section {
  text-align: center;
  color: #888;
  font-style: italic;
  padding: 40px 20px;
  background: #f9f9f9;
  border: 2px dashed #ddd;
  border-radius: 8px;
  margin-bottom: 20px;
}

.form-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  margin-bottom: 6px;
  font-weight: 600;
  color: #555;
  font-size: 14px;
}

.required {
  color: #F44336;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--secondary-color);
  box-shadow: 0 0 0 3px rgba(127, 204, 159, 0.1);
}

.form-group input.error,
.form-group select.error,
.form-group textarea.error {
  border-color: #F44336;
}

.error-text {
  color: #F44336;
  font-size: 12px;
  margin-top: 4px;
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

.form-group input[type="file"] {
  padding: 8px;
  background: #f9f9f9;
}

.file-list {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.file-name {
  background: #e3f2fd;
  color: #1976d2;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.form-actions {
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: #f9f9f9;
}

.cancel-btn {
  padding: 10px 20px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s;
}

.cancel-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #bbb;
}

.save-btn {
  padding: 10px 20px;
  border: none;
  background: var(--ar-buttons-bg);
  color: var(--main-text-color);
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.3s;
}

.save-btn:hover:not(:disabled) {
  background: var(--secondary-color);
}

.cancel-btn:disabled,
.save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .form-content {
    padding: 16px;
  }
  
  .form-header {
    padding: 16px;
  }
  
  .form-actions {
    padding: 16px;
    flex-direction: column-reverse;
  }
  
  .cancel-btn,
  .save-btn {
    width: 100%;
    padding: 12px;
  }
}

@media (max-width: 480px) {
  .form-group input,
  .form-group select,
  .form-group textarea {
    padding: 10px;
  }
  
  .form-header h2 {
    font-size: 1.3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/project/WorkReportForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;;;IAGE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".work-report-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  max-height: 95vh;\r\n  width: 100%;\r\n}\r\n\r\n.form-header {\r\n  padding: 20px 24px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  background: #f9f9f9;\r\n}\r\n\r\n.form-header h2 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.form-tabs {\r\n  display: flex;\r\n  background: #f5f5f5;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  overflow-x: auto;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.form-tabs button {\r\n  padding: 12px 16px;\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #666;\r\n  border-bottom: 3px solid transparent;\r\n  transition: all 0.3s;\r\n  white-space: nowrap;\r\n  min-width: max-content;\r\n}\r\n\r\n.form-tabs button:hover {\r\n  background: #e8e8e8;\r\n  color: #333;\r\n}\r\n\r\n.form-tabs button.active {\r\n  color: var(--secondary-color);\r\n  border-bottom-color: var(--secondary-color);\r\n  background: white;\r\n}\r\n\r\n.form-section {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.form-section h3 {\r\n  margin: 0 0 20px 0;\r\n  color: #333;\r\n  font-size: 1.2rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding-bottom: 10px;\r\n  border-bottom: 2px solid #e0e0e0;\r\n}\r\n\r\n.section-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.section-header h3 {\r\n  margin: 0;\r\n  border-bottom: none;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.add-btn {\r\n  padding: 8px 16px;\r\n  background: var(--secondary-color);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  transition: background 0.3s;\r\n}\r\n\r\n.add-btn:hover {\r\n  background: #6a9c7a;\r\n}\r\n\r\n.form-subsection {\r\n  background: #f9f9f9;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.subsection-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.subsection-header h4 {\r\n  margin: 0;\r\n  color: #555;\r\n  font-size: 1rem;\r\n}\r\n\r\n.remove-btn {\r\n  background: #f44336;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 24px;\r\n  height: 24px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 12px;\r\n  transition: background 0.3s;\r\n}\r\n\r\n.remove-btn:hover {\r\n  background: #d32f2f;\r\n}\r\n\r\n.empty-section {\r\n  text-align: center;\r\n  color: #888;\r\n  font-style: italic;\r\n  padding: 40px 20px;\r\n  background: #f9f9f9;\r\n  border: 2px dashed #ddd;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.form-content {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 24px;\r\n}\r\n\r\n.form-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.form-group.full-width {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.form-group label {\r\n  margin-bottom: 6px;\r\n  font-weight: 600;\r\n  color: #555;\r\n  font-size: 14px;\r\n}\r\n\r\n.required {\r\n  color: #F44336;\r\n}\r\n\r\n.form-group input,\r\n.form-group select,\r\n.form-group textarea {\r\n  padding: 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  transition: border-color 0.3s;\r\n}\r\n\r\n.form-group input:focus,\r\n.form-group select:focus,\r\n.form-group textarea:focus {\r\n  outline: none;\r\n  border-color: var(--secondary-color);\r\n  box-shadow: 0 0 0 3px rgba(127, 204, 159, 0.1);\r\n}\r\n\r\n.form-group input.error,\r\n.form-group select.error,\r\n.form-group textarea.error {\r\n  border-color: #F44336;\r\n}\r\n\r\n.error-text {\r\n  color: #F44336;\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.form-group textarea {\r\n  resize: vertical;\r\n  min-height: 80px;\r\n  font-family: inherit;\r\n}\r\n\r\n.form-group input[type=\"file\"] {\r\n  padding: 8px;\r\n  background: #f9f9f9;\r\n}\r\n\r\n.file-list {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.file-name {\r\n  background: #e3f2fd;\r\n  color: #1976d2;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n}\r\n\r\n.form-actions {\r\n  padding: 16px 24px;\r\n  border-top: 1px solid #e0e0e0;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  background: #f9f9f9;\r\n}\r\n\r\n.cancel-btn {\r\n  padding: 10px 20px;\r\n  border: 1px solid #ddd;\r\n  background: white;\r\n  color: #666;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.cancel-btn:hover:not(:disabled) {\r\n  background: #f5f5f5;\r\n  border-color: #bbb;\r\n}\r\n\r\n.save-btn {\r\n  padding: 10px 20px;\r\n  border: none;\r\n  background: var(--ar-buttons-bg);\r\n  color: var(--main-text-color);\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: background 0.3s;\r\n}\r\n\r\n.save-btn:hover:not(:disabled) {\r\n  background: var(--secondary-color);\r\n}\r\n\r\n.cancel-btn:disabled,\r\n.save-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 768px) {\r\n  .form-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 16px;\r\n  }\r\n  \r\n  .form-content {\r\n    padding: 16px;\r\n  }\r\n  \r\n  .form-header {\r\n    padding: 16px;\r\n  }\r\n  \r\n  .form-actions {\r\n    padding: 16px;\r\n    flex-direction: column-reverse;\r\n  }\r\n  \r\n  .cancel-btn,\r\n  .save-btn {\r\n    width: 100%;\r\n    padding: 12px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .form-group input,\r\n  .form-group select,\r\n  .form-group textarea {\r\n    padding: 10px;\r\n  }\r\n  \r\n  .form-header h2 {\r\n    font-size: 1.3rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
